import React from 'react';

// Components
import ProductImage from 'Components/commonOrder/ProductImage';
import { T } from 'Actions/translate';

class SQuoteItem extends React.Component {
    render() {
        const { item, orderType } = this.props;

        return (
            <div className='s-quote-item'>
                <div className="image-box"><ProductImage src={ item && item.productPic } alt={ item && item.productName }/></div>
                <div className="details">
                    <p className="product-name" dangerouslySetInnerHTML={{ __html: item.productName }} />
                    <p className="sku row text-ellipsis line-one"><label>{T('product_sku_colon')} </label><span>{ item.sku }</span></p>
                    <p className="inventory row text-ellipsis line-one"><label>{T('order_inventory_colon')} </label><span>{orderType ==='SCM' ? (item.availableQuantity > 0 ? item.availableQuantity : 0)
                    :   item.availableQuantity === 0 ? T('stockout') : 
                        item.availableQuantity > 0 && item.availableQuantity <= 10 ? T('short_of_stock') :
                        item.availableQuantity > 10 ? T('in_stock') : null  
                    }</span></p>
                    <p className="specification row text-ellipsis"><label>{T('product_specifications_colon')} </label><span dangerouslySetInnerHTML={{ __html: item.specifications }} /></p>
                </div>
                { this.props.children }
            </div>
        );
    }
}

export default SQuoteItem;
